/**
 * 漏洞补丁说明：与 `src/locales/virus-items/v.{locale}.json` 对齐，key 为纯数字 KB ID（无 KB 前缀）。
 */

/** 从接口 kb_number 解析出 JSON 中的数字 key；CVE 或非数字返回 null */
export function virusKbNumericId(kbNumber: string | undefined | null): string | null {
  const raw = (kbNumber ?? '').trim()
  if (!raw || raw.toUpperCase().includes('CVE-')) return null
  const digits = raw.replace(/^KB\s*/i, '').trim()
  if (!/^\d+$/.test(digits)) return null
  return digits
}

/** i18n 路径 `virusKbDescriptions.<id>`；无映射 key 时返回 null */
export function virusKbDescriptionMessagePath(kbNumber: string | undefined | null): string | null {
  const id = virusKbNumericId(kbNumber)
  return id ? `virusKbDescriptions.${id}` : null
}

/**
 * 若当前语言包中存在该 KB 的文案则返回译文，否则返回 null（由调用方回退接口字段）。
 */
export function resolvedVirusKbDescription(
  kbNumber: string | undefined | null,
  te: (key: string) => boolean,
  t: (key: string) => string,
): string | null {
  const path = virusKbDescriptionMessagePath(kbNumber)
  if (!path || !te(path)) return null
  return t(path)
}
